
const app = {
  path: "/app",
  name: "app",
  component: require("../../components/App/Layout/Layout").default,
  routes: [
    {
      path: "/home",
      name: "app.home",
      allowRoles: ["SystemAdministrator", "CustomerAdmin", "Vendor"],
      component: require("../../components/App/Views/Home").default,
    },
    {
      path: "/trips",
      name: "trips",
      component: require("../../components/App/Views/Trip").default,
      routes: [
        {
          path: '/create',
          name: 'trips.create',
          component: require('../../components/App/Views/Trip/TripEdit').default,
        },
        {
          path: '/:id/update',
          name: 'trips.edit',
          component: require('../../components/App/Views/Trip/TripEdit').default,
        },
        {
          path: '/:id',
          name: 'trips.detail',
          component: require('../../components/App/Views/Trip/TripDetail').default,
        },

      ],
    },
    {
      path: "/tripapprovals",
      name: "tripapprovals",
      component: require("../../components/App/Views/TripApproval").default,
      routes: [
        {
          path: '/:id',
          name: 'tripaprovals.detail',
          component: require('../../components/App/Views/TripApproval/TripApprovalDetail').default,
        },
      ],
    },
    {
      path: "/tripunitapprovals",
      name: "tripunitapprovals",
      component: require("../../components/App/Views/TripUnitApproval").default
    },
    {
      path: "/notifications",
      name: "notifications",
      component: require("../../components/App/Views/Notification").default,
      routes :[]
    },
    {
      path: "/addresses",
      name: "addresses",
      component: require("../../components/App/Views/Address").default,
      routes: [
        {
          path: '/edit/:id',
          name: 'addresses.edit',
          component: require('../../components/App/Views/Address/AddressEdit').default,
        },
        {
          path: '/create',
          name: 'addresses.create',
          component: require('../../components/App/Views/Address/AddressEdit').default,
        }
      ],
    },
    {
      path: "/contacts",
      name: "contacts",
      component: require("../../components/App/Views/Contact").default,
      routes: [
        {
          path: '/edit/:id',
          name: 'contacts.edit',
          component: require('../../components/App/Views/Contact/ContactEdit').default,
        },
        {
          path: '/create',
          name: 'contacts.create',
          component: require('../../components/App/Views/Contact/ContactEdit').default,
        }
      ],
    },
    {
      path: "/accounts",
      name: "accounts",
      component: require("../../components/App/Views/Account").default,
      routes: [
        {
          path: '/profile',
          name: 'accounts.profile',
          component: require('../../components/App/Views/Account/Profile').default,
        },
        {
          path: '/settings',
          name: 'accounts.settings',
          component: require('../../components/App/Views/Account/Settings').default,
        },
        {
          path: '/change-password',
          name: 'accounts.change-password',
          component: require('../../components/App/Views/Account/ChangePassword').default,
        },
        {
          path: '/dashboard',
          name: 'accounts.dashboard',
          component: require('../../components/App/Views/Account/Dashboard').default,
        },
        {
          path: '/logout',
          name: 'accounts.logout',
          component: require('../../components/App/Views/Account/Logout').default,
        }
      ],
    }
  ]
};

export default app;



// WEBPACK FOOTER //
// ./src/plugins/routes/app.js